import styled, { css } from 'styled-components'

import { mobileMediaQuery } from '@subaio/webapp'

export const ContextWrapper = styled.div`
	margin-top: 24px;
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-template-rows: 1fr;
	gap: 24px;

	> :only-child {
		grid-column: 1 / -1;
	}

	${mobileMediaQuery(css`
		grid-template-columns: 1fr;
	`)}
`
